import { memo, useState } from 'react';
import { css } from '@emotion/react';
import { useAppTranslation } from '@hooks';
import { UserDataType } from '@pages/types';
import { Row } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ActionModal, colors, Text } from 'common-components';

import { FormUser, FormUserDataType } from '@views/shared/user';

export type UpdateManagerModalPropsType = {
  managerUser: UserDataType
  isLoading: boolean
  onUpdateManager?: (formManager: FormUserDataType) => Promise<void>
  close: () => void
  isOpen: boolean
};

const UpdateManagerModalComponent = ({
  managerUser,
  isLoading,
  close,
  isOpen,
  onUpdateManager,
}: UpdateManagerModalPropsType) => {
  const [managerForm, setManagerForm] = useState<FormUserDataType>(null);

  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  const { translate } = useAppTranslation();

  return (
    <ActionModal
      mask={{ closable: false }}
      width={660}
      open={isOpen}
      onOk={close}
      customHeader={
        <Row
          css={css`
            flex-direction: column;
            gap: 5px;
          `}
        >
          <Text
            css={css`
              font-weight: 500;
            `}
            color={colors.gray900}
            size="lg"
          >
            {translate('managers.updateManager')}
          </Text>
        </Row>
      }
      onConfirm={close}
      onCancel={close}
      actionButtons={[
        {
          text: translate('managers.cancel'),
          onClick: () => {
            close();
          },
        },
        {
          text: isLoading ? <LoadingOutlined /> : translate('managers.confirm'),
          type: 'primary',
          disabled: !isFormValid,
          onClick: () => onUpdateManager(managerForm),
        },
      ]}
    >
      <FormUser
        roles={['admin', 'manager']}
        user={{
          idUser: managerUser?.idUser,
          type: managerUser?.type,
          email: managerUser?.email,
          firstName: managerUser?.firstName,
          lastName: managerUser?.lastName,
          phone: managerUser?.phone,
          urlAvatar: managerUser?.urlAvatar,
        }}
        mode="edit"
        isFormValid={setIsFormValid}
        onChangeForm={setManagerForm}
      />
    </ActionModal>
  );
};

const UpdateManagerModal = memo(
  UpdateManagerModalComponent,
  (oldProps: UpdateManagerModalPropsType, newProps: UpdateManagerModalPropsType) => {
    return JSON.stringify(oldProps) === JSON.stringify(newProps);
  },
);

export default UpdateManagerModal;
